import createPhoneInput, {
    countries,
} from "country-phone-mask";
export function phone(){
    const container = document.querySelectorAll(".phone-input");

    container.forEach((item) => {
        createPhoneInput({
            container: item,
            countries,
			spritePath: "/local/templates/rtk/images/sprite2.svg", // можно переопределить путь
            apiKey: "",
        });
    })
}